const LINKEDIN_CAROUSEL_URL = 'https://buffer.com/resources/linkedin-carousels/'
const GENERIC_MEDIA_URL =
  'https://buffer.com/resources/data-best-content-format-social-media/'

export function getMediaLearnMoreUrl(service?: string | null): string {
  return service === 'linkedin' ? LINKEDIN_CAROUSEL_URL : GENERIC_MEDIA_URL
}
